import { render, staticRenderFns } from "./inventory-services-link.vue?vue&type=template&id=bcc54fc8&"
import script from "./inventory-services-link.vue?vue&type=script&lang=js&"
export * from "./inventory-services-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports